import { useEffect, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextCheckbox } from '../typography/typography.styles';
import {
  CheckboxWrapper,
  CheckboxContainer,
  CheckboxContent,
} from './checkbox.styles';
import InputMessage from '../input-message/input-message.component';
import { ReactComponent as CheckboxIcon } from '../../assets/checkbox-icon.svg';

interface Props {
  name: string;
  ariaLabel?: string;
  children: React.ReactNode;
  isChecked: boolean;
  isError?: { value: boolean };
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxPlain = ({
  isChecked,
  isError = { value: false },
  name,
  ariaLabel,
  children,
  onChange,
}: Props) => {
  const id = useId();

  const { t } = useTranslation();

  const [errorAnimationKey, setErrorAnimationKey] = useState(0);

  useEffect(() => {
    if (isError.value) {
      setErrorAnimationKey((prev) => prev + 1); // triggers a key update to re-animate
    }
  }, [isError]);

  return (
    <CheckboxWrapper>
      <CheckboxContainer
        key={errorAnimationKey}
        $isError={isError.value}>
        <input
          id={name + id}
          name={name}
          aria-label={ariaLabel}
          type='checkbox'
          checked={isChecked}
          onChange={onChange}
        />
        <CheckboxContent>
          <CheckboxIcon />
        </CheckboxContent>
      </CheckboxContainer>
      {children && <TextCheckbox>{children}</TextCheckbox>}
      {isError.value && (
        <InputMessage
          hasIcon={false}
          type='error'>
          {t('checkbox_error')}
        </InputMessage>
      )}
    </CheckboxWrapper>
  );
};

export default CheckboxPlain;
